import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { useMemo } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { getCache, setCache } from '@/utils/cache'
import { FunctionComponentChildren } from '@/@types/react'
import { useNavigation } from '@/hooks/useNavigation'

const RequireAuthentication: FunctionComponentChildren<RouteProps> = ({
  children,
  component: Component,
  ...rest
}) => {
  const navigate = useNavigation()
  const uniqueCode = useMemo(() => {
    return getCache<string>('unique-code')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.path])

  const { token, user, users } = useAuthContext()
  return (
    <Route
      {...rest}
      render={props => {
        const ROUTES_WITHOUT_STATE = ['/autenticacao-dois-fatores']
        const routeState: Record<string, unknown> = {}

        if (!ROUTES_WITHOUT_STATE.includes(props.location.pathname)) {
          routeState.from = props.location
        }

        if (token && user) {
          return Component ? <Component {...props} /> : { children }
        } else if (users) {
          return (
            <Redirect
              to={{
                pathname: uniqueCode ? `/escolha/${uniqueCode}` : '/escolha',
                state: routeState,
              }}
            />
          )
        } else {
          if (props.location.pathname !== '/') {
            setCache('link-to-redirect-after-login', props.location.pathname)
          }
          // It was necessary to switch to navigate because with Redirect it was not possible to add replace
          navigate(uniqueCode ? `/login/${uniqueCode}` : '/login', {
            state: routeState,
            replace: true,
          })
        }
      }}
    />
  )
}

export default RequireAuthentication
